import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { getWageringTemplateDetailsStart, updateWageringTemplateStart } from '../../../../store/redux-slices/bonus'
import { getAllCasinoGamesStart } from '../../../../store/redux-slices/superAdminCasinoManagement'
import useDidMountEffect from '../../../../utils/useDidMountEffect'

const useEditWageringTemplate = () => {
  const { loading, wageringTemplateDetail } = useSelector((state) => state.bonus)
  const { casinoGamesData } = useSelector((state) => state.superAdminCasino)
  const { wageringTemplateId } = useParams()
  const [selectedProvider, setSelectedProvider] = useState('')
  const [gameContribution, setGameContribution] = useState({ })
  const [customValue, setCustomValue] = useState()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  const [contributionDefaultValue, setContributionDefaultValue] = useState({})
  const isInitialRender = useDidMountEffect()

  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)

  const totalPages = Math.ceil(casinoGamesData?.count / limit)

  const customValueHandler = (value) => {
    setCustomValue(value)
    const newGameContribution = {}
    for (const key in gameContribution) {
      newGameContribution[key] = value
    }
    setGameContribution(newGameContribution)
  }

  const formSubmitHandler = (formValue) => {
    const templateData = {
      name: formValue.name,
      gameContribution: { ...contributionDefaultValue, ...gameContribution },
      wageringTemplateId: Number(wageringTemplateId)
    }
    dispatch(updateWageringTemplateStart({ isTenant: false, templateData, navigate }))
  }

  const fetchDetails = () => {
    dispatch(getWageringTemplateDetailsStart({
      isTenant: false,
      wageringTemplateId,
      limit: 15,
      pageNo: 1,
      providerId: selectedProvider
    }))
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          dispatch(
            getAllCasinoGamesStart({
              limit,
              pageNo: page,
              casinoCategoryId: '',
              search,
              isActive: '',
              tenantId: '',
              selectedProvider
            })
          )
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  useEffect(() => {
    dispatch(
      getAllCasinoGamesStart({
        limit,
        pageNo: page,
        casinoCategoryId: '',
        search,
        isActive: '',
        tenantId: '',
        selectedProvider
      })
    )
  }, [selectedProvider, page, limit])

  useEffect(() => {
    fetchDetails()
  }, [selectedProvider])

  useEffect(() => {
    if (wageringTemplateDetail) {
      setContributionDefaultValue(wageringTemplateDetail?.gameContribution)
    }
  }, [wageringTemplateDetail])

  return {
    loading,
    navigate,
    page,
    limit,
    setLimit,
    setPage,
    totalPages,
    selectedProvider,
    setSelectedProvider,
    gameContribution,
    casinoGamesData,
    setGameContribution,
    customValue,
    customValueHandler,
    wageringTemplateDetail,
    formSubmitHandler,
    search,
    setSearch,
    setContributionDefaultValue,
    contributionDefaultValue
  }
}

export default useEditWageringTemplate
